import { useOTAFileList } from '@services/ota'
import { Select, SelectProps } from '@shared/Form/Select'

export const OTAFilesSelect = (props: SelectProps) => {
  const { dataSource, loading } = useOTAFileList(
    {
      pageNum: 0,
      pageSize: 9999,
    },
    {
      refetchOnMount: true,
    }
  )

  return (
    <Select
      loading={loading}
      showSearch
      filterOption={(input, option) =>
        typeof option?.children === 'string' &&
        (option.children as string).includes(input)
      }
      optionFilterProp="label"
      {...props}>
      {dataSource?.content?.map(x => (
        <Select.Option key={x.id} value={x.id}>
          {x.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export default OTAFilesSelect
